import type { FC } from 'react'
import { H3, useIsMobileVariant } from '@dhl-ui/components'

type PageTitleProps = {
  title: string
}

/**
 * Page title but never on mobile variant
 */
export const PageTitle: FC<PageTitleProps> = ({ title }) => {
  const isMobileVariant = useIsMobileVariant()

  if (isMobileVariant) {
    return null
  }

  return <H3 sx={{ mb: 3 }}>{title}</H3>
}
